import { createRouter, createWebHashHistory } from "vue-router";
import Login from "@/pages/Login";

const routes = [
    {
        path: '/', redirect: '/login'
    },
    {
        path: '/home',
        component: () => import('@/components/Layout'),
        children: [
            {
                path: '',
                component: () => import('@/pages/Home')
            },
            {
                path: 'analysisHome',
                component: () => import('@/pages/Analysis')
            },
            {
                path: 'historicalOrders',
                component: () => import('@/pages/HistoricalOrders')
            },
            {
                path: 'storePromotion',
                component: () => import('@/pages/StorePromotion')
            },
            {
                path: 'exposureShop',
                component: () => import('@/pages/ExposureShop')
            },
            {
                path: 'business',
                component: () => import('@/pages/Business')
            },
            {
                path: 'traffic',
                component: () => import('@/pages/Traffic')
            },
            {
                path: 'allHistory',
                component: () => import('@/pages/AllHistory')
            }
        ]
    },
    {
        path: '/login',
        component: Login
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

export default router